import React, {Component} from 'react';
import './App.css';


import {  withTranslation, Trans } from 'react-i18next';
import InfinityLoading from "./img/infinity.svg";
// import ProjectTextBox from "./ContentComponents/ProjectTextBox";
import { ReferencesData } from './contentData';

import Helmet from "react-helmet/es/Helmet";
import ReferencesDetailBox from "./components/ReferencesDetailBox";


class References extends Component {

    constructor(props) {
        super(props);

        this.timeout = null;
        this.page = 1;
        this.requestId = null;
        this.state = {
            activeFilters : {
                services : [],
                expertise : [],
                countries : []
            },
            referenceTypes : "",
            filterChanged : false,
            moreReferences : true,
            loadingMore : false,
            noResults : false,
            stateChangin: 1,
            references : [],
            filters : {}
        };

        // this.filterOnChecked = this.filterOnChecked.bind(this);
        // this.loadMoreReferences = this.loadMoreReferences.bind(this);
    }

    // loadReferences(loadMore = false) {
    //     let url = new URL(window.API + '/references/list');
    //     Object.keys(this.state.activeFilters).forEach(key => url.searchParams.append(key, this.state.activeFilters[key]));
    //
    //     if (loadMore) {
    //         this.page = this.page + 1;
    //         url.searchParams.append('page', this.page);
    //         this.setState({ loadingMore :  true });
    //     } else {
    //         this.requestId = (new Date()).getTime().toString();
    //         url.searchParams.append('requestId', this.requestId);
    //     }
    //
    //     fetch(url)
    //         .then(response => response.json())
    //         .then(data => {
    //             if (data.requestId && this.requestId !== data.requestId) { return; }
    //             this.setState(state => {
    //                 if (loadMore) {
    //                     state.references.push(...data.references);
    //                 } else {
    //                     state.references = data.references;
    //                 }
    //
    //                 state.noResults = data.references.length === 0 && data.end;
    //                 state.moreReferences = !data.end;
    //                 state.filterChanged = false;
    //                 state.loadingMore = false;
    //                 state.loaded = true;
    //                 return state;
    //             });
    //         });
    // }

    componentDidMount() {
        const { i18n } = this.props;

        let url = new URL(window.location.href);

        console.log(url.pathname);


            this.setState({
                referenceTypes : "pozemni-stavby",
                references: []
            }, function () {
                var ReferenceDatasArray = [];

                ReferencesData.reference.map((reference, i) =>
                {
                    console.log("Entered", this.state.references);
                    ReferenceDatasArray.push(<ReferencesDetailBox name={reference.name}
                                                              type={"pozemni"}
                                                              link={"/reference/"+reference.id}
                                                              image_folder={reference.image_folder}
                                                              kratky_popis={reference.kratky_popis}
                                                              popis={reference.popis}
                                                              architekt={reference.architekt}
                                                              realizacni_firma={reference.realizacni_firma}
                                                              projektant={reference.projektant}
                                                              investicni_naklady={reference.investicni_naklady}/>);
                    //   var joined = this.state.references.concat( <ReferencesDetailBox name={reference.name} type={"pozemni"} link={"/projekty/pozemni-stavby/projekt1"}/>);
                    // console.log("Entered2", joined);

                    // Return the element. Also pass key
                    //  return (<Answer key={answer} answer={answer} />)
                });
                this.setState({ references: ReferenceDatasArray });
            });




    }

    componentDidUpdate(prevProps, prevState) {



        const { i18n } = this.props;

        let url = new URL(window.location.href);

        console.log(url.pathname);


            if (prevState.stateChangin !== this.state.stateChangin) {
                this.setState({
                    referenceTypes : "pozemni-stavby",
                    references: []
                }, function () {
                    var ReferenceDatasArray = [];

                    ReferencesData.reference.map((reference, i) =>
                    {
                        console.log("Entered", this.state.references);
                        ReferenceDatasArray.push(<ReferencesDetailBox name={reference.name}
                                                                  type={"pozemni"}
                                                                  link={"/reference/pozemni-stavby/"+reference.id}
                                                                  image_folder={reference.image_folder}
                                                                  kratky_popis={reference.kratky_popis}
                                                                  popis={reference.popis}
                                                                  architekt={reference.architekt}
                                                                  realizacni_firma={reference.realizacni_firma}
                                                                  projektant={reference.projektant}
                                                                  investicni_naklady={reference.investicni_naklady}/>);
                        //   var joined = this.state.references.concat( <ReferencesDetailBox name={reference.name} type={"pozemni"} link={"/projekty/pozemni-stavby/projekt1"}/>);
                        // console.log("Entered2", joined);

                        // Return the element. Also pass key
                        //  return (<Answer key={answer} answer={answer} />)
                    });
                    this.setState({ references: ReferenceDatasArray });

                });
            }

    }



    render() {
        const { i18n, t } = this.props;




        return (
            <div>
                <Helmet>
                    <title>{i18n.exists('references.seo.title') ? t('references.seo.title') : "Agile CE"}</title>
                    <meta name="description" content={i18n.exists('references.seo.description') ? t('references.seo.description') : ""} />
                    <meta property="og:title" content={i18n.exists('references.seo.title') ? t('references.seo.title') : "Agile CE"} />
                    <meta property="og:description" content={i18n.exists('references.seo.description') ? t('references.seo.description') : ""} />
                </Helmet>


                    <div className="container content fade-in-website" id="references">
                        <div id={"references-filter"}>
                            <button className={"active"}><h3>Pozemní stavby</h3></button>
                            <button><h3>Inženýrské konstrukce</h3></button>

                        </div>
                        <div>
                            {this.state.references}
                        </div>


                    </div>



            </div>
        );
    }
}

export default withTranslation()(References);
